var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 54,
    viewBox: "0 0 76 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2762 46.584H46.0677V48.3568H29.2762V46.584Z",
    fill: "#4A3A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7603 49.7275C48.7603 50.4847 48.1586 51.0986 47.4149 51.0986H27.9318C27.1881 51.0986 26.5863 50.4847 26.5863 49.7275V46.5837H0V46.5985C0 50.6795 3.25857 54 7.26347 54H68.0832C72.0881 54 75.3466 50.6795 75.3466 46.5985V46.5837H48.7603V49.7275Z",
    fill: "#4A3A80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48539 4.03081V43.8415H68.866V4.03081C68.866 1.80821 67.0909 0 64.9098 0H10.4417C8.26052 0 6.48539 1.80821 6.48539 4.03081Z",
    fill: "#4A3A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.a5ca791ee1b5237a882cd1eccb5399ec.svg";
export { ForwardRef as ReactComponent };